var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationBar'),_c('TrainingMenu'),_c('CourseBreadcrumb'),_c('router-view',{staticClass:"m-3"}),_c('FooterView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }